import { z } from 'zod';
import { RECONCILIATION_OPERATION } from '../pages/admin/company/constants/peerDiff';
import { tableUpdateInfoSchema } from './tableUpdate.schemas';

const ownerSchema = z.object({
    fullName: z.string(),
    disabled: z.boolean(),
});

export const updateReviewSchema = z.object({
    id: z.number(),
    type: z.string(),
    status: z.string(),
    ownerId: z.number(),
    owner: ownerSchema.optional(),
    schemaId: z.number().nullable(),
    notes: z.string().nullish(),
});

export type UpdateReviewType = z.infer<typeof updateReviewSchema>;

export const appliedUpdateSchema = tableUpdateInfoSchema.pick({
    id: true,
    companyId: true,
    srcSchemaId: true,
    summary: true,
    description: true,
    phase: true,
    purpose: true,
    ownerId: true,
    createdOn: true,
    updatedOn: true,
}).extend({
    owner: ownerSchema.optional(),
    reviews: z.array(updateReviewSchema),
});

export type AppliedUpdateType = z.infer<typeof appliedUpdateSchema>;

export const updateReconciliationsSchema = tableUpdateInfoSchema.pick({
    id: true,
    srcSchemaId: true,
}).extend({
    reconciliationEvents: z.array(z.object({
        schemaId: z.number(),
        reportId: z.number(),
        descriptorId: z.string(),
        property: z.string(),
        currentValue: z.string(),
        targetValue: z.string(),
        operation: z.nativeEnum(RECONCILIATION_OPERATION),
        riskLevel: z.number(),
    })),
});

export type UpdateReconciliationsType = z.infer<typeof updateReconciliationsSchema>;
